<template>
  <van-cell v-for="(item,index) in books" :key="index">
    <router-link class="book-item" :to="'/orderBookDetail/' + item.book.bookId" v-if="item.book">
      <div class="cover">
				<img v-if="item.book.coverUrl" :src="item.book.coverUrl" :key="item.book.bookId" @error="handleErrorImage($event)"/>
				<img v-else :src="defaultCover()" :key="item.book.bookId"/>
      </div>
      <div class="right">
        <p class="title">{{ item.book.title }}</p>
        <p>{{ item.book.author }}</p>
        <p>{{ item.book.publisher }}</p>
        <p>
          <span class="price">￥{{ item.book.price }}</span>
          <!--
          <span class="stock">库存:{{ item.inventory }}</span>
          -->
        </p>
      </div>
    </router-link>
  </van-cell>
</template>

<script>
import {
  defineComponent,
  computed,
} from "vue";
import {randomBookCover} from "@/utils/util";

export default defineComponent({
  name: 'Book',
  props: {
    list: {
      // 图书信息
      type: Array,
      default: () => []
    },
  },
  setup(props) {
    const books = computed(() => {
      return props.list;
    });
		function handleErrorImage(event){
			event.srcElement.src = randomBookCover();
		}
		function defaultCover(){
			return randomBookCover();
		}
    return {
      books,
			handleErrorImage,
			defaultCover
    };
  },
});
</script>

<style scoped lang="less">
@import "../assets/css/book.less";
</style>
